export const SHOW_SEARCH = 'SHOW_SEARCH'
export const UPDATE_VISIBILITY = 'UPDATE_VISIBILITY'
export const HIDE_SEARCH = 'HIDE_SEARCH'
export const SHOW_LEGEND = 'SHOW_LEGEND'
export const HIDE_LEGEND = 'HIDE_LEGEND'
export const SET_CONFIG = 'SET_CONFIG'
export const SET_SEARCHPARAMS = 'SET_SEARCHPARAMS'
export const UPDATE_GEMEENTEN = 'UPDATE_GEMEENTEN'

const ALL_MUTATIONS = {
    UPDATE_VISIBILITY,
    SHOW_SEARCH,
    HIDE_SEARCH,
    SHOW_LEGEND,
    HIDE_LEGEND,
    SET_CONFIG,
    SET_SEARCHPARAMS,
    UPDATE_GEMEENTEN
}

export default ALL_MUTATIONS